module.exports = require("babel-runtime/helpers/typeof");